import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'water',
      d: 'M-1.5,-3h1v0.5h-1zM-2,-2.5h2.5v0.5h-2.5zM-6.5,-2h0.5v0.5h-0.5zM-5,-2h0.5v0.5h-0.5zM-2.5,-2h3v0.5h-3zM4,-2h0.5v0.5h-0.5zM5.5,-2h0.5v0.5h-0.5zM-7,-1.5h1v1.5h-1zM-3.5,-1.5h3v0.5h-3zM2.5,-1.5h4v0.5h-4zM-4,-1h3.5v0.5h-3.5zM2.5,-1h4.5v0.5h-4.5zM-3,-0.5h1.5v0.5h-1.5zM3,-0.5h0.5v0.5h-0.5zM5,-0.5h2v1h-2zM-7,0h4v0.5h-4zM0.5,0h2.5v0.5h-2.5zM-6.5,0.5h3v0.5h-3zM0,0.5h3v0.5h-3zM5.5,0.5h1v0.5h-1zM-5.5,1h2.5v0.5h-2.5zM0,1h6v0.5h-6zM-3,1.5h0.5v0.5h-0.5zM2,1.5h2v0.5h-2z',
    },
    { paint: 'waterLight', d: 'M3,-2h1v0.5h-1zM4.5,-2h1v0.5h-1z' },
    {
      paint: 'reeds',
      d: 'M-6,-4.5h1v1h-1zM-6,-3.5h2v0.5h-2zM-6,-3h1v1.5h-1zM-6,-1.5h0.5v0.5h-0.5zM2,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'leaf',
      d: 'M0.5,-2h1v0.5h-1zM2.5,-2h0.5v0.5h-0.5zM-5.5,-1.5h2v0.5h-2zM0.5,-1.5h2v0.5h-2zM-6,-1h2v0.5h-2zM1.5,-1h0.5v0.5h-0.5zM-6,-0.5h3v0.5h-3zM-1.5,-0.5h0.5v0.5h-0.5zM1,-0.5h2v0.5h-2zM3.5,-0.5h1.5v0.5h-1.5zM-3,0h2.5v0.5h-2.5zM3,0h2v0.5h-2zM-3.5,0.5h3.5v0.5h-3.5zM3,0.5h2.5v0.5h-2.5zM-3,1h3v0.5h-3zM-2,1.5h1v0.5h-1z',
    },
    {
      paint: 'flower',
      d: 'M1.5,-5h1.5v1h-1.5zM-3.5,-4h0.5v0.5h-0.5zM0,-4h0.5v0.5h-0.5zM1,-4h1.5v0.5h-1.5zM4,-4h1v0.5h-1zM-4,-3.5h1.5v0.5h-1.5zM0,-3.5h1v1h-1zM1.5,-3.5h1v0.5h-1zM3,-3.5h2v0.5h-2zM-5,-3h0.5v1h-0.5zM-4,-3h1v0.5h-1zM-2.5,-3h1v0.5h-1zM3,-3h1.5v0.5h-1.5zM-3,-2.5h1v0.5h-1zM0.5,-2.5h1v0.5h-1zM2.5,-2.5h2v0.5h-2zM-4.5,-2h0.5v0.5h-0.5zM-3,-2h0.5v0.5h-0.5zM1.5,-2h1v0.5h-1zM-0.5,-1.5h1v0.5h-1zM-0.5,-1h0.5v0.5h-0.5zM0.5,-1h1v0.5h-1zM-1,-0.5h0.5v0.5h-0.5zM0.5,-0.5h0.5v0.5h-0.5zM-0.5,0h1v0.5h-1z',
    },
    {
      paint: 'cherryPetalWhite',
      d: 'M2.5,-4h1v0.5h-1zM1,-3.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v0.5h-0.5zM-4.5,-3h0.5v0.5h-0.5zM-3,-3h0.5v0.5h-0.5zM1,-3h2v0.5h-2zM-4.5,-2.5h1.5v0.5h-1.5zM1.5,-2.5h0.5v0.5h-0.5zM-4,-2h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM-0.5,-0.5h1v0.5h-1z',
    },
    { paint: 'flowerCenter', d: 'M2,-2.5h0.5v0.5h-0.5z' },
  ],
  pixels: 269,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'water',
      d: 'M2,-3h0.5v0.5h-0.5zM5,-3h1.5v0.5h-1.5zM0.5,-2.5h1v0.5h-1zM5,-2.5h2v0.5h-2zM-5.5,-2h1.5v0.5h-1.5zM-1.5,-2h3v0.5h-3zM5.5,-2h1.5v1h-1.5zM-6,-1.5h3v0.5h-3zM-0.5,-1.5h2.5v0.5h-2.5zM-7,-1h0.5v0.5h-0.5zM-5.5,-1h1.5v0.5h-1.5zM-1,-1h8v0.5h-8zM-7,-0.5h1v0.5h-1zM-1,-0.5h7.5v0.5h-7.5zM-7,0h0.5v1h-0.5zM0,0h5.5v0.5h-5.5zM-3,0.5h3.5v0.5h-3.5zM-4,1h4v0.5h-4zM-5,1.5h4v0.5h-4z',
    },
    { paint: 'waterLight', d: 'M0.5,0.5h4v0.5h-4zM2,1h1v0.5h-1z' },
    {
      paint: 'reeds',
      d: 'M1,-5h0.5v1h-0.5zM2.5,-5h0.5v1h-0.5zM1,-4h1v0.5h-1zM1,-3.5h1.5v0.5h-1.5zM1.5,-3h0.5v1h-0.5zM2.5,-3h0.5v0.5h-0.5zM-6.5,-2.5h0.5v0.5h-0.5zM-6.5,-2h1v0.5h-1zM-6.5,-1.5h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM-6.5,-1h1v0.5h-1zM-6,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'leaf',
      d: 'M3,-3h0.5v0.5h-0.5zM4.5,-3h0.5v0.5h-0.5zM2,-2.5h3v0.5h-3zM1.5,-2h4v0.5h-4zM-3,-1.5h0.5v0.5h-0.5zM-2,-1.5h1.5v0.5h-1.5zM2,-1.5h3.5v0.5h-3.5zM-4,-1h3v0.5h-3zM-5.5,-0.5h4.5v0.5h-4.5zM-6.5,0h6.5v0.5h-6.5zM-6.5,0.5h3.5v0.5h-3.5zM-6,1h2v0.5h-2z',
    },
    {
      paint: 'flower',
      d: 'M-2.5,-5.5h0.5v0.5h-0.5zM-3,-5h1.5v0.5h-1.5zM3.5,-5h1.5v0.5h-1.5zM-3.5,-4.5h2v0.5h-2zM3.5,-4.5h1v0.5h-1zM5.5,-4.5h0.5v0.5h-0.5zM-5,-4h0.5v0.5h-0.5zM-3.5,-4h1.5v0.5h-1.5zM-0.5,-4h1v0.5h-1zM2.5,-4h0.5v0.5h-0.5zM3.5,-4h0.5v0.5h-0.5zM5,-4h1v0.5h-1zM-5,-3.5h1v0.5h-1zM-3.5,-3.5h1v0.5h-1zM-1.5,-3.5h2v1h-2zM2.5,-3.5h1v0.5h-1zM4.5,-3.5h1.5v0.5h-1.5zM-5.5,-3h1.5v0.5h-1.5zM-3,-3h0.5v0.5h-0.5zM3.5,-3h1v0.5h-1zM-5,-2.5h1.5v0.5h-1.5zM-2,-2.5h2v0.5h-2zM-4,-2h1v0.5h-1zM-2,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'cherryPetalWhite',
      d: 'M4.5,-4.5h0.5v0.5h-0.5zM-2,-4h1v0.5h-1zM3,-4h0.5v0.5h-0.5zM4,-4h1v0.5h-1zM-4,-3.5h0.5v0.5h-0.5zM-2.5,-3.5h1v1h-1zM3.5,-3.5h1v0.5h-1zM-4,-3h1v0.5h-1zM-3.5,-2.5h1.5v0.5h-1.5zM-3,-2h1v0.5h-1z',
    },
  ],
  pixels: 282,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'water',
      d: 'M-5,-3h0.5v1h-0.5zM-3.5,-3h1v0.5h-1zM-2,-3h5v0.5h-5zM-0.5,-2.5h2.5v0.5h-2.5zM3,-2.5h0.5v0.5h-0.5zM-1.5,-2h2v0.5h-2zM6,-2h0.5v0.5h-0.5zM-7,-1.5h1v1h-1zM5.5,-1.5h1.5v0.5h-1.5zM-3.5,-1h1v0.5h-1zM-1.5,-1h0.5v0.5h-0.5zM6,-1h1v0.5h-1zM-7,-0.5h0.5v0.5h-0.5zM-4,-0.5h3v0.5h-3zM2,-0.5h1v0.5h-1zM5,-0.5h2v0.5h-2zM-7,0h1v0.5h-1zM-3.5,0h2v0.5h-2zM1.5,0h1.5v0.5h-1.5zM6,0h0.5v0.5h-0.5zM-6.5,0.5h4.5v0.5h-4.5zM1,0.5h2.5v0.5h-2.5zM-4,1h2v0.5h-2zM2,1h2.5v0.5h-2.5zM-3,1.5h1.5v0.5h-1.5zM1.5,1.5h2v0.5h-2z',
    },
    {
      paint: 'reeds',
      d: 'M-6.5,-4h0.5v1h-0.5zM-5.5,-3.5h0.5v0.5h-0.5zM-6.5,-3h1.5v0.5h-1.5zM-6.5,-2.5h1v1h-1zM-1,-2.5h0.5v0.5h-0.5zM-6,-1.5h1v0.5h-1z',
    },
    {
      paint: 'leaf',
      d: 'M-2.5,-3h0.5v0.5h-0.5zM-2,-2.5h1v0.5h-1zM2,-2.5h0.5v0.5h-0.5zM-2.5,-2h1v0.5h-1zM1,-2h1.5v0.5h-1.5zM-3.5,-1.5h3.5v0.5h-3.5zM1,-1.5h2v0.5h-2zM-6,-1h2.5v0.5h-2.5zM-2.5,-1h1v0.5h-1zM2,-1h4v0.5h-4zM-6.5,-0.5h2.5v0.5h-2.5zM3,-0.5h2v0.5h-2zM-6,0h2.5v0.5h-2.5zM-1.5,0h1.5v0.5h-1.5zM0.5,0h1v0.5h-1zM3,0h3v0.5h-3zM-2,0.5h3v0.5h-3zM3.5,0.5h2.5v0.5h-2.5zM-2,1h4v0.5h-4zM-1.5,1.5h3v0.5h-3zM-0.5,2h1v0.5h-1z',
    },
    {
      paint: 'flower',
      d: 'M-1,-7.5h0.5v0.5h-0.5zM-1.5,-7h1.5v0.5h-1.5zM-2,-6.5h2.5v0.5h-2.5zM-2,-6h2v0.5h-2zM2,-6h0.5v0.5h-0.5zM-3.5,-5.5h1v0.5h-1zM-2,-5.5h1.5v0.5h-1.5zM1,-5.5h1.5v0.5h-1.5zM-4,-5h1.5v0.5h-1.5zM-1.5,-5h1v0.5h-1zM0.5,-5h2v1h-2zM-3.5,-4.5h1v0.5h-1zM-3.5,-4h1.5v0.5h-1.5zM0,-4h2v0.5h-2zM-4,-3.5h0.5v0.5h-0.5zM-2.5,-3.5h1v0.5h-1zM-0.5,-3.5h1.5v0.5h-1.5zM3.5,-3.5h1.5v1h-1.5zM-4.5,-3h1v0.5h-1zM-5.5,-2.5h0.5v1h-0.5zM-4.5,-2.5h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM2.5,-2.5h0.5v1h-0.5zM3.5,-2.5h1v0.5h-1zM5,-2.5h1.5v0.5h-1.5zM-3.5,-2h1v0.5h-1zM0.5,-2h0.5v0.5h-0.5zM5,-2h1v0.5h-1zM-5,-1.5h0.5v0.5h-0.5zM0,-1.5h1v0.5h-1zM3,-1.5h0.5v0.5h-0.5zM4.5,-1.5h1v0.5h-1zM-1,-1h0.5v0.5h-0.5zM0,-1h0.5v0.5h-0.5zM1,-1h1v1h-1zM-1,-0.5h1v0.5h-1zM0,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'cherryPetalWhite',
      d: 'M0,-6h1v0.5h-1zM-2.5,-5.5h0.5v0.5h-0.5zM-0.5,-5.5h1.5v0.5h-1.5zM-2.5,-5h1v0.5h-1zM-0.5,-5h1v0.5h-1zM-2.5,-4.5h3v0.5h-3zM-2,-4h1v0.5h-1zM-0.5,-4h0.5v0.5h-0.5zM-1.5,-3.5h1v0.5h-1zM-4,-2.5h0.5v0.5h-0.5zM4.5,-2.5h0.5v0.5h-0.5zM-5,-2h1.5v0.5h-1.5zM3,-2h2v0.5h-2zM-4.5,-1.5h0.5v0.5h-0.5zM3.5,-1.5h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM0,-0.5h1v0.5h-1z',
    },
    { paint: 'flowerCenter', d: 'M-1,-4h0.5v0.5h-0.5zM-4,-1.5h0.5v0.5h-0.5zM4,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 320,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
